/**
 * Fotografías de producto de la landing. Todas son piezas de dirección de arte
 * (jabones terminados, texturas y presentación para venta) y se usan como
 * apoyo visual de cada sección, nunca como galería independiente.
 */
export const PHOTOS = {
  /** Mesa de trabajo muy clara y desenfocada: fondo del hero. */
  heroBackdrop:
    'https://cdn.magicpatterns.com/patterns/generated-images/e1f17828-6fef-4d1c-beab-4bd0cb963ef0.jpg',
  /** Base de glicerina volcándose en el molde: bloque problema/solución. */
  process:
    'https://cdn.magicpatterns.com/patterns/generated-images/2a4bf6d9-4793-4fd4-86a1-fa2938e1ef6e.jpg',
  /** Colección amplia de jabones: fondo de la sección de biblioteca. */
  collection:
    'https://cdn.magicpatterns.com/patterns/generated-images/3345068a-39fe-4e79-a52f-8be66bbc5728.jpg',
  /** Mosaico "qué podés fabricar". */
  botanical:
    'https://cdn.magicpatterns.com/patterns/generated-images/67492967-c45e-40b7-b178-f3b4c31f7d10.jpg',
  marbled:
    'https://cdn.magicpatterns.com/patterns/generated-images/58a28085-8cec-43db-9bec-1e1f75ff6e94.jpg',
  layered:
    'https://cdn.magicpatterns.com/patterns/generated-images/ad33f1a9-7053-4d22-84df-d1872b245a00.jpg',
  gourmet:
    'https://cdn.magicpatterns.com/patterns/generated-images/d4e082ae-338f-420d-96ab-b5bad3504749.jpg',
  /** Miniaturas de resultado de cada tomo. */
  tomo1:
    'https://cdn.magicpatterns.com/patterns/generated-images/ad13784a-bbc5-4828-8dbe-a6cea4f13d35.jpg',
  tomo2:
    'https://cdn.magicpatterns.com/patterns/generated-images/b8efad6a-8c95-40bf-982a-5c967bd0195c.jpg',
  tomo3:
    'https://cdn.magicpatterns.com/patterns/generated-images/72a75a1b-bbfd-4c14-aa43-d91463930519.jpg',
  tomo4:
    'https://cdn.magicpatterns.com/patterns/generated-images/9fef8ef1-cb32-414a-bd90-ae1d496781f7.jpg',
  /** Macro de la textura de un jabón cortado: ficha de fórmula. */
  macro:
    'https://cdn.magicpatterns.com/patterns/generated-images/0e8609e7-d5b4-49db-bb80-bdef5b2116a5.jpg',
  /** Escritorio de emprendimiento artesanal: bonos. */
  workspace:
    'https://cdn.magicpatterns.com/patterns/generated-images/a78187c6-b60a-461b-94a0-885400ff70aa.jpg',
  /** Emprendimiento artesanal desde casa: packs, cajas y sets listos para entregar. */
  business:
    'https://cdn.magicpatterns.com/patterns/generated-images/fe111f1d-2f2f-4272-aaff-efca38d64e11.jpg',
  /** Detalle de un jabón con faja de papel y etiqueta. */
  businessDetail:
    'https://cdn.magicpatterns.com/patterns/generated-images/a802b195-5501-46b0-8e66-71b7bab331ee.jpg',
  /** Jabones empaquetados y listos para vender: oferta. */
  packaging:
    'https://cdn.magicpatterns.com/patterns/generated-images/707599cc-2727-411c-8370-797070357500.jpg',
  /** Banda panorámica de cierre. */
  finale:
    'https://cdn.magicpatterns.com/patterns/generated-images/d4a45295-48dc-4422-b5e1-a84f1c37e3fc.jpg',
} as const

/** Alt descriptions compartidas para el mosaico de variedad. */
export const VARIETY_PHOTOS = [
  { src: PHOTOS.botanical, alt: 'Jabones de glicerina transparentes con flores y botánicos' },
  { src: PHOTOS.marbled, alt: 'Jabones artesanales marmolados en tonos lavanda y rosa' },
  { src: PHOTOS.layered, alt: 'Jabones en capas de colores suaves' },
  { src: PHOTOS.gourmet, alt: 'Jabones gourmet con formas inspiradas en postres' },
] as const
